<!-- Exam Scheduled Modal2 Content -->
<div id="calledExamScheduledModalNew">
  <div md-dialog-content class="{{ effectiveExamStatusIsIn(['EXAMSTOSCHEDULE','SCHEDULED']) ? 'largePopup' : ''}}">
    <a (click)="closeDialog()" class="md-dialog-close waves-effect closebtncls">
      <i class="material-icons btn-floating btn-small waves-effect waves-light cross-icon-bg #2196f3"></i>
    </a>
    <div class="ExamScheduledModalSecCls">
      <div class="examScheduleModelRow1 {{ _utility.examModelRow1CSSClass(dashboardModel.selectedExamModel) }} {{ effectiveExamStatusIs('EXAMSEXPIRED')?'grayTopRow':'' || effectiveExamStatusIs('COMPLETED')?'firstrowonly':'' }}">
        <div class="popupTopRow1Sec">
          <h3 class="examNameInPopup">{{ dashboardModel.selectedExamModel.examCode }}
            <span class="examTitleNameInPopup">{{ dashboardModel.selectedExamModel.examName }}</span>
          </h3>
          <div class="locationInfoSectionCls">
            <ng-container *ngIf="effectiveExamStatusIsIn(['SCHEDULED', 'COMPLETED'])">
              <div class="examDetailContentInfo" *ngIf="!_utility.usesVirtualLocation(dashboardModel.selectedExamModel); else virtualLocationInfo">
                <span class="locNameCls">{{ dashboardModel.selectedExamModel.locationName }}</span>
                <span class="locAddressCls"><label class="adrsTitleCls">Address:</label>{{ dashboardModel.selectedExamModel.locationAddress }}</span>
                <span class="locPhoneCls"><label class="phoneTitleCls">Contact No:</label>{{ dashboardModel.selectedExamModel.locationContactNumber }}</span>
              </div>
              <ng-template #virtualLocationInfo>
              <div class="examDetailContentInfo">
                <span class="locAddressCls"><label class="adrsTitleCls">Country:</label>{{ dashboardModel.selectedExamModel.locationCountryName }}</span>
              </div>
              </ng-template>
            </ng-container>
          </div>
        </div>
        <div class="examScheduleDetailListSec {{ _utility.examScheduleDetailListSecCSSClass(dashboardModel.selectedExamModel) }}">
          <ul class="examScheduleDetailList wdthAuto">
            <li>Eligibility Code
              <span class="examDetailDateButton roundedCorner {{ _utility.examBackgroundCSSClass(dashboardModel.selectedExamModel)}}">
                {{ dashboardModel.selectedExamModel.eligibilityCode }}
              </span>
            </li>
            <li *ngIf="dashboardModel.selectedExamModel.examStartDateTime">Exam Time
              <span class="examDetailDateButton roundedCorner {{ _utility.examBackgroundCSSClass(dashboardModel.selectedExamModel)}}">
                {{ dashboardModel.selectedExamModel.examStartDateTime | dateTimeFormat : _appConfig.timeFormatExamCards }}
              </span>
            </li>
            <li *ngIf="dashboardModel.selectedExamModel.examStartDateTime">Exam TimeZone
              <span class="examDetailDateButton roundedCorner {{ _utility.examBackgroundCSSClass(dashboardModel.selectedExamModel)}}">
              {{ dashboardModel.selectedExamModel.timeZone }}
            </span>
            </li>
            <li *ngIf="dashboardModel.selectedExamModel.examStartDateTime">Exam Date
              <span class="examDetailDateButton roundedCorner {{ _utility.examBackgroundCSSClass(dashboardModel.selectedExamModel)}}">
                {{ dashboardModel.selectedExamModel.examStartDateTime | dateTimeFormat : _appConfig.dateFormat }}
              </span>
            <li *ngIf="effectiveExamStatusIsIn(['EXAMSEXPIRED', 'EXAMSTOSCHEDULE', 'SCHEDULED']) && dashboardModel.selectedExamModel.eligibilityExpirationDate">
              Expiration Date
              <span class="examDetailDateButton roundedCorner {{ _utility.examBackgroundCSSClass(dashboardModel.selectedExamModel)}}">
                {{ dashboardModel.selectedExamModel.eligibilityExpirationDate | dateTimeFormat : _appConfig.dateFormat }}
                <small *ngIf="!effectiveExamStatusIs('EXAMSEXPIRED')" class="expiryMess"
                  mdTooltip="Expires in {{ _utility.daysUntil(_utility.convertToDateTime(dashboardModel.selectedExamModel.eligibilityExpirationDate)) }} Day(s)">
                  <i class="material-icons">&#xE88F;</i>
                </small>
              </span>
            </li>
            <li *ngIf="dashboardModel.selectedExam">Exam Type
              <span class="examDetailDateButton roundedCorner {{ _utility.examBackgroundCSSClass(dashboardModel.selectedExamModel)}}">
                {{ _utility.getExamTypeDisplay(dashboardModel.selectedExam.examType) }}
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div class="parent-row2-row3" *ngIf="effectiveExamStatusIsIn(['EXAMSTOSCHEDULE','SCHEDULED'])">
        <div *ngIf="effectiveExamStatusIsIn(['EXAMSTOSCHEDULE','SCHEDULED'])"
          class="examScheduleModelRow2">
          <p class="prompt-text">This prompt is for COUNTRY OF GOVERNMENT-ISSUED PHOTO ID</p>
          <div class="countrySec">
            <div class="countryRightSec">
              <div class="countryRightSecContent">
                <md-select placeholder="Select Country" id="cmbCountry" name="cmbCountry" required
                  [(ngModel)]="dashboardModel.selectedCountry" (ngModelChange)="selectCountry()" floatPlaceholder="float">
                  <md-option *ngFor="let item of dashboardModel.countryList" [value]="item">
                    {{item.name}}
                  </md-option>
                </md-select>
              </div>
              <div *ngIf="_utility.isAdminAsCandidate() && dashboardModel.isCountrySelected && dashboardModel.selectedCountry.isRequired">
                <div style="font-size: small;" *ngIf="dashboardModel.userInfo.idStatus == null || _utility.convertToCase(dashboardModel.userInfo.idStatus) != _utility.convertToCase('APPROVED'); else candidateIdApproved">
                  The candidate must have a verified government ID before scheduling. Please direct them to <a href="https://red.ht/exam_id_upload" target="_blank">red.ht/exam_id_upload</a>
                </div>
                <ng-template #candidateIdApproved>
                  <div style="font-size: small;">The candidate's government ID has been verified</div>
                </ng-template>
              </div>
              <div *ngIf="!_utility.isAdminAsCandidate() && dashboardModel.isCountrySelected && dashboardModel.selectedCountry.isRequired" class="countryRightSecContent">
                <div *ngIf="_utility.convertToCase(dashboardModel.userInfo.idStatus) == _utility.convertToCase('APPROVED'); else idNotApproved">
                  <p class="id-not-req" style="margin: 10px 0;">Your government ID has been verified</p>
                </div>
                <ng-template #idNotApproved>
                  <div class="id-not-req">Photo ID verification is required for this country
                    <a href="https://red.ht/exam_id_upload" target="_blank" class="mat-raised-button redBackground" style="text-decoration: none; margin-left: 1rem; padding: 0 16px; font-weight: bold; text-transform: uppercase; display: inline-block;">
                      Verify your ID
                    </a>
                  </div>
                </ng-template>
              </div>
              <div *ngIf="dashboardModel.isCountrySelected && !dashboardModel.selectedCountry.isRequired" class="id-not-req">No ID verification required</div>
            </div>
          </div>
          <div class="uploadIDSec">
          </div>
        </div>
        <div class="examScheduleModelRow3">
          <div class="fullWidth" *ngIf="!additionalInfoRequired; else additionalInfoRequiredForm">
            <ng-container *ngIf="!showExamOptionsForReschedule">
              <div *ngIf="effectiveExamStatusIs('SCHEDULED')"
                 (click)="cancelExam()" class="examScheduleModelCalendarTab">
                <a href="javascript:void(0);"> <span class="cancelExamIcon"></span>Cancel</a>
              </div>
            </ng-container>
            <ng-container *ngIf="dashboardModel.isCountrySelected && (_utility.convertToCase(dashboardModel.userInfo.idStatus) == _utility.convertToCase('APPROVED') || !dashboardModel.selectedCountry.isRequired)">
              <ng-container *ngIf="!showExamOptionsForReschedule">
                <div *ngIf="effectiveExamStatusIs('SCHEDULED')"
                  (click)="scheduleExam()" class="examScheduleModelCalendarTab">
                  <a href="javascript:void(0);"><span class="rescheduleIcon"></span>Reschedule</a>
                </div>
                <div *ngIf="canChangeType()" (click)="showExamOptionsForReschedule = true" class="examScheduleModelCalendarTab">
                  <a href="javascript:void(0);"><span class="rescheduleIcon"></span>Change Type</a>
                </div>
              </ng-container>
              <ng-container *ngIf="effectiveExamStatusIs('EXAMSTOSCHEDULE') || showExamOptionsForReschedule">
                <div class="examSec">
                  <div class="examRightSec">
                    <div class="examRightSecContent">
                      <div>
                        <p class="prompt-text">This prompt is for the EXAM TYPE</p>
                        <md-select placeholder="Select exam type" id="cmbType" name="cmdType" required
                          (ngModelChange)="selectExamType()"
                          [(ngModel)]="dashboardModel.selectedExamType" floatPlaceholder="float">
                          <md-option
                            *ngFor="let examType of dashboardModel.availableExamTypes"
                            [value]="examType">
                            {{ convertExamTypeToDisplay(examType) | titlecase }}
                          </md-option>
                        </md-select>
                        <p class="prompt-text">This prompt is for the EXAM</p>
                        <md-select placeholder="Select Exam" id="cmbSku" name="cmbSku" required
                          [disabled]="dashboardModel.availableExams.length === 0"
                          (ngModelChange)="selectExamOption(exam)"
                          [(ngModel)]="dashboardModel.selectedExam" floatPlaceholder="float">
                          <md-option
                            *ngFor="let exam of dashboardModel.availableExams"
                            [value]="exam">
                            {{ exam.examName | titlecase }}
                          </md-option>
                        </md-select>
                      </div>
                    </div>
                  </div>
                  <ng-container *ngIf="dashboardModel.selectedExam">
                    <a href="javascript:void(0);">
                      <ng-container *ngIf="showExamOptionsForReschedule; else showExamOptionsForSchedule">
                        <div [title]="dashboardModel.selectedExamModel.examOptions.length > 1 ? getExamDisplayName(dashboardModel.selectedExamModel.examCodeName) : ''" (click)="scheduleExam()">
                            <span class="rescheduleIcon"></span>{{_utility.getExamTypeDisplay(dashboardModel.selectedExam.examType)}} {{dashboardModel.selectedExam.examName}}
                        </div>
                      </ng-container>
                      <ng-template #showExamOptionsForSchedule>
                        <div [title]="dashboardModel.selectedExamModel.examOptions.length > 1 ? getExamDisplayName(dashboardModel.selectedExamModel.examCodeName) : ''" (click)="scheduleExam()">
                          <span class="scheduleIcon"></span><div>{{ dashboardModel.selectedExamModel.examOptions.length > 1 ? _utility.getExamTypeDisplay(dashboardModel.selectedExam.examType) : "Schedule" }}</div>
                        </div>
                      </ng-template>
                    </a>
                    <ng-container *ngIf="examObjectivesIsEnabled">
                      <a target="_blank" [href]="getObjectivesUrl()" style="margin-left: 1em;">
                        <span class="objectivesIcon"><img src="assets/images/objectives.svg" width="55" height="30" alt="objectives"/></span>
                        <div>Objectives</div>
                      </a>
                    </ng-container>
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
          </div>
          <div *ngIf="showExamOptionsForReschedule && !additionalInfoRequired" class="fullWidth">
            <a href="javascript:void(0);" (click)="resetExamSelection()">Back</a>
          </div>
          <ng-template #additionalInfoRequiredForm>
            <div class="fullWidth">
              <p class="prompt-text" style="padding-bottom: 2em;">Additional information about where you will be taking your exam is required:</p>
            </div>
            <div class="fullWidth">
              <form [formGroup]="additionalInfoForm">
                <md-form-field class="example-full-width fullWidth">
                  <input required class="fullWidth" type="text" placeholder="Time Zone" mdInput formControlName="timeZoneControl" [mdAutocomplete]="timeZone" [showDropDown]="{model: 'timeZone', scope: this, formAttr: 'additionalInfoForm'}">
                  <md-autocomplete #timeZone="mdAutocomplete" [displayWith]="_utility.displayFn">
                    <md-option *ngFor="let option of timeZoneFilteredOptions | async" [value]="option">
                      {{ option.name }}
                    </md-option>
                  </md-autocomplete>
                </md-form-field>
                <md-form-field class="example-full-width fullWidth">
                  <input required type="text" placeholder="Country" mdInput formControlName="countryControl" [mdAutocomplete]="virtualLocationCountry" [showDropDown]="{model: 'virtualLocationCountry', scope: this, formAttr: 'additionalInfoForm'}">
                  <md-autocomplete #virtualLocationCountry="mdAutocomplete" [displayWith]="_utility.displayFn">
                    <md-option *ngFor="let option of virtualLocationCountryFilteredOptions | async" [value]="option">
                      {{ option.name }}
                    </md-option>
                  </md-autocomplete>
                </md-form-field>
                <div class="fullWidth" style="padding-top: 1em;">
                  <button style="float: right;" class="mat-raised-button stdBtn" (click)="scheduleExam()">Continue</button>
                  <a href="javascript:void(0);" (click)="resetExamSelection()">Back</a>
                </div>
              </form>
            </div>
          </ng-template>
          <div *ngIf="!(showExamOptionsForReschedule || additionalInfoRequired) && effectiveExamStatusIs('SCHEDULED') && dashboardModel.selectedExamModel.onboardingUrl" class="fullWidth startExam">
            <a class="mat-raised-button redBackground" href="{{ dashboardModel.selectedExamModel.onboardingUrl }}" target="_blank">Start Exam</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/dialog-exam-details/dialog-exam-details.component.html